import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Empty, Row, Col, List, Button, Spin } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { S3ACCESSURL } from '../../../databucket';

const MyHandbooks = () => {

    const employeeHandbooks = useSelector((state) => state?.handbooks?.myHandbooks || []);
    const loading = useSelector((state) => state?.handbooks?.myLoading);

    const [selectedHandbook, setSelectedHandbook] = useState(null);

    // Set first handbook as selected when handbooks load
    useEffect(() => {
        if (employeeHandbooks && employeeHandbooks.length > 0 && !selectedHandbook) {
            setSelectedHandbook(employeeHandbooks[0]);
        }
    }, [employeeHandbooks, selectedHandbook]);

    const isPdf = (filename) => filename?.toLowerCase().endsWith('.pdf');

    return (
        <div className="card profile-box flex-fill">
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div style={{ marginBottom: 16 }}>
                        <h3 style={{ margin: 0 }}>My Handbooks</h3>
                    </div>

                    {loading ? (
                        <Spin />
                    ) : employeeHandbooks && employeeHandbooks.length ? (
                        <Row gutter={[16, 16]} style={{ height: 'calc(100vh - 200px)' }}>
                            {/* Sidebar: List of Handbooks */}
                            <Col xs={24} sm={24} md={6} style={{ borderRight: '1px solid #f0f0f0', overflowY: 'auto', maxHeight: '600px' }}>
                                <h4 style={{ marginBottom: 12 }}>Handbooks</h4>
                                <List
                                    dataSource={employeeHandbooks}
                                    renderItem={(hb) => (
                                        <List.Item
                                            onClick={() => setSelectedHandbook(hb)}
                                            style={{
                                                padding: '12px',
                                                cursor: 'pointer',
                                                backgroundColor: selectedHandbook?._id === hb._id ? '#e6f7ff' : '#fff',
                                                borderLeft: selectedHandbook?._id === hb._id ? '3px solid #1677ff' : 'none',
                                                marginBottom: 8,
                                                borderRadius: 4,
                                            }}
                                        >
                                            <div>
                                                <div style={{ fontWeight: 600, fontSize: 13 }}>{hb.name}</div>
                                                <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                                                    {hb.description || 'No description'}
                                                </div>
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            </Col>

                            {/* Main Area: PDF Viewer or Document View */}
                            <Col xs={24} sm={24} md={18} style={{ overflowY: 'auto', maxHeight: '600px' }}>
                                {selectedHandbook ? (
                                    <Card bordered bodyStyle={{ padding: '16px' }}>
                                        <div style={{ marginBottom: 16 }}>
                                            <h4>{selectedHandbook.name}</h4>
                                            <p style={{ color: '#666', marginBottom: 8 }}>
                                                {selectedHandbook.description || 'No description available'}
                                            </p>
                                            <small style={{ color: '#999' }}>
                                                Updated: {new Date(parseInt(selectedHandbook.updatedAt)).toLocaleDateString()}
                                            </small>
                                        </div>

                                        {selectedHandbook.file?.data ? (
                                            <div style={{ border: '1px solid #d9d9d9', borderRadius: 4, overflow: 'hidden' }}>
                                                {isPdf(selectedHandbook.file.filename) ? (
                                                    <iframe
                                                        src={S3ACCESSURL + selectedHandbook.file.data}
                                                        title="PDF Viewer"
                                                        width="100%"
                                                        height="600px"
                                                        style={{
                                                            border: 'none',
                                                            borderRadius: 4,
                                                        }}
                                                    />
                                                ) : (
                                                    <div style={{ backgroundColor: '#f5f5f5', padding: '16px', textAlign: 'center' }}>
                                                        <FileOutlined style={{ fontSize: 48, color: '#1677ff', marginBottom: 12 }} />
                                                        <div style={{ marginBottom: 12 }}>
                                                            <strong>{selectedHandbook.file.filename}</strong>
                                                        </div>
                                                        <Button
                                                            type="primary"
                                                            onClick={() => {
                                                                window.open(S3ACCESSURL + selectedHandbook.file.data, '_blank');
                                                            }}
                                                        >
                                                            Download File
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <Empty description="No file attached to this handbook" />
                                        )}
                                    </Card>
                                ) : (
                                    <Empty description="Select a handbook to view" />
                                )}
                            </Col>
                        </Row>
                    ) : (
                        <Empty description="No handbooks available" />
                    )}
                </div>
            </div>
        </div>
    );
};

export default MyHandbooks;
